/**
* Stories JS
* -----------------------------------------------------------------------------
*
* All the JS for the Stories component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'stories',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.stories' ).each( function( key, component ) {
        const stories = new Splide( $( component ).find( '.splide--stories' )[0], {
          type: 'fade',
          pagination: false,
          arrows: false,
          perPage: 1,
          perMove: 1,
          keyboard: true,
          rewind: true,
          drag: false,
        } );

        stories.mount();

        $( component ).find( '.stories__nav--prev' ).on( 'click', function() {
          stories.go( '<' );
        } );

        $( component ).find( '.stories__nav--next' ).on( 'click', function() {
          stories.go( '>' );
        } );

        $( component ).find( '.stories__nav--go-to' ).on( 'click', function() {
          stories.go( parseInt( $( this ).attr( 'data-slide' ) ) );
        } );

        stories.on( 'mounted moved', function() {
          const activeSlide = stories.Components.Elements.slides[stories.index];
          $( component ).find( '.splide__track' ).height( activeSlide.offsetHeight + 'px' );
          ScrollTrigger.refresh();
        } );

        // Trigger the resize on initial load
        const activeSlide = stories.Components.Elements.slides[stories.index];
        $( component ).find( '.splide__track' ).height( activeSlide.offsetHeight + 'px' );
        ScrollTrigger.refresh();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'stories', COMPONENT );
} )( app );
